import { render, staticRenderFns } from "./TextBoxCard.vue?vue&type=template&id=6a75e790&scoped=true"
import script from "./TextBoxCard.vue?vue&type=script&lang=ts"
export * from "./TextBoxCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a75e790",
  null
  
)

export default component.exports